export default {
  'multi-area-change': {
    name: 'Area Change',
    icon: 'object-ungroup',
    threshold: () => { return false },
    condition: (val) => { return `On ${val ? 'entry' : 'exit'}` }
  },
  'area-change': {
    name: 'Area Change',
    icon: 'draw-polygon',
    threshold: () => { return false },
    condition: (val) => { return `On ${val ? 'entry' : 'exit'}` }
  },
  'continuous-driving-distance': {
    name: 'Continuous Driving Distance',
    icon: 'ruler',
    threshold: (val) => { return `After ${val}km` },
    condition: () => { return false }
  },
  'continuous-driving-time': {
    name: 'Continuous Driving Time',
    icon: 'stopwatch',
    threshold: (val) => { return `After ${val} minutes` },
    condition: () => { return false }
  },
  'driver-login-reminder': {
    name: 'Driver Login Reminder',
    icon: 'user-check',
    threshold: (val) => { return `After ${val} seconds` },
    condition: () => { return false }
  },
  'exceeding-absolute-speed-limit': {
    name: 'Exceeding Absolute Speed Limit',
    icon: 'tachometer-fast',
    threshold: (val) => { return `${val}km/h` },
    condition: () => { return false }
  },
  'exceeding-road-speed-limit': {
    name: 'Exceeding Road Speed Limit',
    icon: 'tachometer-alt-fast',
    threshold: (val) => { return `${val}km/h above` },
    condition: () => { return false }
  },
  'exceeding-vehicle-speed-limit': {
    name: 'Exceeding Vehicle Speed Limit',
    icon: 'shipping-fast',
    threshold: (val) => { return `${val}km/h above` },
    condition: (val) => { return `Fallback: ${val}km/h` }
  },
  'excessive-idling': {
    name: 'Excessive Idling',
    icon: 'hourglass-half',
    threshold: (val) => { return `After ${val} minutes` },
    condition: () => { return false }
  },
  'excessive-standstill': {
    name: 'Excessive Standstill',
    icon: 'parking',
    threshold: (val) => { return `After ${val} minutes` },
    condition: () => { return false }
  },
  'fuel-level-change': {
    name: 'Fuel Level Change',
    icon: 'gas-pump',
    threshold: () => { return false },
    condition: (val) => { return `${val < 2 ? val === 1 ? 'On increase' : 'On decrease' : 'On increase or decrease' }` }
  },
  'health-check': {
    name: 'Health Check',
    icon: 'heartbeat',
    threshold: (val) => { return `No activity for ${val} hours` },
    condition: () => { return false }
  },
  'ignition-change': {
    name: 'Ignition Change',
    icon: 'key',
    threshold: () => { return false },
    condition: (val) => { return `${val < 2 ? val === 1 ? 'At ignition on' : 'At ignition off' : 'At ignition on or off' }` }
  },
  'panic-button': {
    name: 'Panic Button',
    icon: 'siren-on',
    threshold: () => { return false },
    condition: () => { return false }
  }
}